//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ExternalAccountsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type ExternalAccountsGetProvidersExternalAccountsQueryParameters = {
  countryCode: string ;
}

export type ExternalAccountsGetAccountExternalAccountsQueryParameters = {
  provider: string ;
  accountIdentifier?: string | undefined ;
}

export type ExternalAccountsUpdateAccountExternalAccountsQueryParameters = {
  provider: string ;
  accountIdentifier?: string | undefined ;
}

export type ExternalAccountsDeleteAccountExternalAccountsQueryParameters = {
  provider: string ;
  accountIdentifier?: string | undefined ;
}

export type ExternalAccountsGetPortfoliosExternalAccountsQueryParameters = {
  provider: string ;
  accountIdentifier?: string | undefined ;
}

export type ExternalAccountsAuthenticateInitExternalAccountsQueryParameters = {
  provider: string ;
}

export type ExternalAccountsAuthenticateCollectExternalAccountsQueryParameters = {
  provider: string ;
}

export type ExternalAccountsSyncExternalPortfoliosBankIdExternalAccountsQueryParameters = {
  provider: string ;
}

export function externalAccountsGetProvidersUrl(countryCode: string): string {
  let url_ = getBaseUrl() + "/api/external/providers?";
  if (countryCode === undefined || countryCode === null)
    throw new Error("The parameter 'countryCode' must be defined and cannot be null.");
  else
    url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let externalAccountsGetProvidersDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfAccountProviderDto, unknown, Types.ListResultDtoOfAccountProviderDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfAccountProviderDto, unknown, Types.ListResultDtoOfAccountProviderDto>, 'queryFn'>> = {
};
export function getExternalAccountsGetProvidersDefaultOptions() {
  return externalAccountsGetProvidersDefaultOptions;
};
export function setExternalAccountsGetProvidersDefaultOptions(options: typeof externalAccountsGetProvidersDefaultOptions) {
  externalAccountsGetProvidersDefaultOptions = options;
}

export function externalAccountsGetProvidersQueryKey(countryCode: string): QueryKey;
export function externalAccountsGetProvidersQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { countryCode,  } = params[0] as ExternalAccountsGetProvidersExternalAccountsQueryParameters;

    return trimArrayEnd([
        'ExternalAccountsClient',
        'externalAccountsGetProviders',
        countryCode as any,
      ]);
  } else {
    return trimArrayEnd([
        'ExternalAccountsClient',
        'externalAccountsGetProviders',
        ...params
      ]);
  }
}
export function __externalAccountsGetProviders(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.externalAccountsGetProviders(
      context.queryKey[2] as string,axiosConfig    );
}

export function useExternalAccountsGetProvidersQuery<TSelectData = Types.ListResultDtoOfAccountProviderDto, TError = unknown>(dto: ExternalAccountsGetProvidersExternalAccountsQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfAccountProviderDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useExternalAccountsGetProvidersQuery<TSelectData = Types.ListResultDtoOfAccountProviderDto, TError = unknown>(countryCode: string, options?: Omit<UseQueryOptions<Types.ListResultDtoOfAccountProviderDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useExternalAccountsGetProvidersQuery<TSelectData = Types.ListResultDtoOfAccountProviderDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfAccountProviderDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let countryCode: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ countryCode,  } = params[0] as ExternalAccountsGetProvidersExternalAccountsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [countryCode, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfAccountProviderDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __externalAccountsGetProviders(context, axiosConfig) : __externalAccountsGetProviders,
    queryKey: externalAccountsGetProvidersQueryKey(countryCode),
    ...externalAccountsGetProvidersDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfAccountProviderDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setExternalAccountsGetProvidersData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfAccountProviderDto | undefined) => Types.ListResultDtoOfAccountProviderDto, countryCode: string) {
  queryClient.setQueryData(externalAccountsGetProvidersQueryKey(countryCode),
    updater
  );
}

/**
 * @return OK
 */
export function setExternalAccountsGetProvidersDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfAccountProviderDto | undefined) => Types.ListResultDtoOfAccountProviderDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function externalAccountsGetAccountsUrl(): string {
  let url_ = getBaseUrl() + "/api/external/accounts";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let externalAccountsGetAccountsDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfExternalAccountDto, unknown, Types.ListResultDtoOfExternalAccountDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfExternalAccountDto, unknown, Types.ListResultDtoOfExternalAccountDto>, 'queryFn'>> = {
};
export function getExternalAccountsGetAccountsDefaultOptions() {
  return externalAccountsGetAccountsDefaultOptions;
};
export function setExternalAccountsGetAccountsDefaultOptions(options: typeof externalAccountsGetAccountsDefaultOptions) {
  externalAccountsGetAccountsDefaultOptions = options;
}

export function externalAccountsGetAccountsQueryKey(): QueryKey;
export function externalAccountsGetAccountsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'ExternalAccountsClient',
      'externalAccountsGetAccounts',
    ]);
}
export function __externalAccountsGetAccounts(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.externalAccountsGetAccounts(
axiosConfig    );
}

/**
 * @return OK
 */
export function useExternalAccountsGetAccountsQuery<TSelectData = Types.ListResultDtoOfExternalAccountDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.ListResultDtoOfExternalAccountDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useExternalAccountsGetAccountsQuery<TSelectData = Types.ListResultDtoOfExternalAccountDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfExternalAccountDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfExternalAccountDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __externalAccountsGetAccounts(context, axiosConfig) : __externalAccountsGetAccounts,
    queryKey: externalAccountsGetAccountsQueryKey(),
    ...externalAccountsGetAccountsDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfExternalAccountDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setExternalAccountsGetAccountsData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfExternalAccountDto | undefined) => Types.ListResultDtoOfExternalAccountDto, ) {
  queryClient.setQueryData(externalAccountsGetAccountsQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setExternalAccountsGetAccountsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfExternalAccountDto | undefined) => Types.ListResultDtoOfExternalAccountDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function externalAccountsGetAccountUrl(provider: string, accountIdentifier?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/external/accounts/{provider}?";
if (provider === undefined || provider === null)
  throw new Error("The parameter 'provider' must be defined.");
url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
if (accountIdentifier === null)
    throw new Error("The parameter 'accountIdentifier' cannot be null.");
else if (accountIdentifier !== undefined)
    url_ += "accountIdentifier=" + encodeURIComponent("" + accountIdentifier) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let externalAccountsGetAccountDefaultOptions: Omit<UseQueryOptions<Types.ExternalAccountDto, unknown, Types.ExternalAccountDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ExternalAccountDto, unknown, Types.ExternalAccountDto>, 'queryFn'>> = {
};
export function getExternalAccountsGetAccountDefaultOptions() {
  return externalAccountsGetAccountDefaultOptions;
};
export function setExternalAccountsGetAccountDefaultOptions(options: typeof externalAccountsGetAccountDefaultOptions) {
  externalAccountsGetAccountDefaultOptions = options;
}

export function externalAccountsGetAccountQueryKey(dto: ExternalAccountsGetAccountExternalAccountsQueryParameters): QueryKey;
export function externalAccountsGetAccountQueryKey(provider: string, accountIdentifier?: string | undefined): QueryKey;
export function externalAccountsGetAccountQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { provider, accountIdentifier,  } = params[0] as ExternalAccountsGetAccountExternalAccountsQueryParameters;

    return trimArrayEnd([
        'ExternalAccountsClient',
        'externalAccountsGetAccount',
        provider as any,
        accountIdentifier as any,
      ]);
  } else {
    return trimArrayEnd([
        'ExternalAccountsClient',
        'externalAccountsGetAccount',
        ...params
      ]);
  }
}
export function __externalAccountsGetAccount(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.externalAccountsGetAccount(
      context.queryKey[2] as string,       context.queryKey[3] as string | undefined,axiosConfig    );
}

export function useExternalAccountsGetAccountQuery<TSelectData = Types.ExternalAccountDto, TError = unknown>(dto: ExternalAccountsGetAccountExternalAccountsQueryParameters, options?: Omit<UseQueryOptions<Types.ExternalAccountDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function useExternalAccountsGetAccountQuery<TSelectData = Types.ExternalAccountDto, TError = unknown>(provider: string, accountIdentifier?: string | undefined, options?: Omit<UseQueryOptions<Types.ExternalAccountDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useExternalAccountsGetAccountQuery<TSelectData = Types.ExternalAccountDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ExternalAccountDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let provider: any = undefined;
  let accountIdentifier: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ provider, accountIdentifier,  } = params[0] as ExternalAccountsGetAccountExternalAccountsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [provider, accountIdentifier, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ExternalAccountDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __externalAccountsGetAccount(context, axiosConfig) : __externalAccountsGetAccount,
    queryKey: externalAccountsGetAccountQueryKey(provider, accountIdentifier),
    ...externalAccountsGetAccountDefaultOptions as unknown as Omit<UseQueryOptions<Types.ExternalAccountDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function setExternalAccountsGetAccountData(queryClient: QueryClient, updater: (data: Types.ExternalAccountDto | undefined) => Types.ExternalAccountDto, provider: string, accountIdentifier?: string | undefined) {
  queryClient.setQueryData(externalAccountsGetAccountQueryKey(provider, accountIdentifier),
    updater
  );
}

/**
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function setExternalAccountsGetAccountDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ExternalAccountDto | undefined) => Types.ExternalAccountDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function externalAccountsUpdateAccountUrl(provider: string, accountIdentifier?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/external/accounts/{provider}?";
if (provider === undefined || provider === null)
  throw new Error("The parameter 'provider' must be defined.");
url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
if (accountIdentifier === null)
    throw new Error("The parameter 'accountIdentifier' cannot be null.");
else if (accountIdentifier !== undefined)
    url_ += "accountIdentifier=" + encodeURIComponent("" + accountIdentifier) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function externalAccountsUpdateAccountMutationKey(provider: string, accountIdentifier?: string | undefined): MutationKey {
  return trimArrayEnd([
      'ExternalAccountsClient',
      'externalAccountsUpdateAccount',
      provider as any,
      accountIdentifier as any,
    ]);
}

/**
 * @param accountIdentifier (optional) 
 * @param body (optional) 
 * @return OK
 */
export function useExternalAccountsUpdateAccountMutation<TContext>(provider: string, accountIdentifier?: string | undefined, options?: Omit<UseMutationOptions<Types.ExternalAccountDto, unknown, Types.ExternalAccountUpdateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ExternalAccountDto, unknown, Types.ExternalAccountUpdateDto, TContext> {
  const key = externalAccountsUpdateAccountMutationKey(provider, accountIdentifier);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ExternalAccountUpdateDto) => Client.externalAccountsUpdateAccount(provider, accountIdentifier, body),
    mutationKey: key,
  });
}
  
type ExternalAccountsUpdateAccount__MutationParameters = ExternalAccountsUpdateAccountExternalAccountsQueryParameters & {
  body: Types.ExternalAccountUpdateDto;
}

/**
 * @param accountIdentifier (optional) 
 * @param body (optional) 
 * @return OK
 */
export function useExternalAccountsUpdateAccountMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.ExternalAccountDto, unknown, ExternalAccountsUpdateAccount__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ExternalAccountsUpdateAccountExternalAccountsQueryParameters}): UseMutationResult<Types.ExternalAccountDto, unknown, ExternalAccountsUpdateAccount__MutationParameters, TContext> {
  const key = externalAccountsUpdateAccountMutationKey(options?.parameters?.provider!, options?.parameters?.accountIdentifier!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ExternalAccountsUpdateAccount__MutationParameters) => Client.externalAccountsUpdateAccount(data.provider ?? options?.parameters?.provider!, data.accountIdentifier ?? options?.parameters?.accountIdentifier!, data.body),
  mutationKey: key,
});
}
  
export function externalAccountsDeleteAccountUrl(provider: string, accountIdentifier?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/external/accounts/{provider}?";
if (provider === undefined || provider === null)
  throw new Error("The parameter 'provider' must be defined.");
url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
if (accountIdentifier === null)
    throw new Error("The parameter 'accountIdentifier' cannot be null.");
else if (accountIdentifier !== undefined)
    url_ += "accountIdentifier=" + encodeURIComponent("" + accountIdentifier) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function externalAccountsDeleteAccountMutationKey(provider: string, accountIdentifier?: string | undefined): MutationKey {
  return trimArrayEnd([
      'ExternalAccountsClient',
      'externalAccountsDeleteAccount',
      provider as any,
      accountIdentifier as any,
    ]);
}

/**
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function useExternalAccountsDeleteAccountMutation<TContext>(provider: string, accountIdentifier?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = externalAccountsDeleteAccountMutationKey(provider, accountIdentifier);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.externalAccountsDeleteAccount(provider, accountIdentifier),
    mutationKey: key,
  });
}
  
type ExternalAccountsDeleteAccount__MutationParameters = ExternalAccountsDeleteAccountExternalAccountsQueryParameters

/**
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function useExternalAccountsDeleteAccountMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ExternalAccountsDeleteAccount__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ExternalAccountsDeleteAccountExternalAccountsQueryParameters}): UseMutationResult<void, unknown, ExternalAccountsDeleteAccount__MutationParameters, TContext> {
  const key = externalAccountsDeleteAccountMutationKey(options?.parameters?.provider!, options?.parameters?.accountIdentifier!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ExternalAccountsDeleteAccount__MutationParameters) => Client.externalAccountsDeleteAccount(data.provider ?? options?.parameters?.provider!, data.accountIdentifier ?? options?.parameters?.accountIdentifier!),
  mutationKey: key,
});
}
  
export function externalAccountsGetPortfoliosUrl(provider: string, accountIdentifier?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/external/accounts/{provider}/investments?";
if (provider === undefined || provider === null)
  throw new Error("The parameter 'provider' must be defined.");
url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
if (accountIdentifier === null)
    throw new Error("The parameter 'accountIdentifier' cannot be null.");
else if (accountIdentifier !== undefined)
    url_ += "accountIdentifier=" + encodeURIComponent("" + accountIdentifier) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let externalAccountsGetPortfoliosDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfExternalPortfolioDto, unknown, Types.ListResultDtoOfExternalPortfolioDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfExternalPortfolioDto, unknown, Types.ListResultDtoOfExternalPortfolioDto>, 'queryFn'>> = {
};
export function getExternalAccountsGetPortfoliosDefaultOptions() {
  return externalAccountsGetPortfoliosDefaultOptions;
};
export function setExternalAccountsGetPortfoliosDefaultOptions(options: typeof externalAccountsGetPortfoliosDefaultOptions) {
  externalAccountsGetPortfoliosDefaultOptions = options;
}

export function externalAccountsGetPortfoliosQueryKey(dto: ExternalAccountsGetPortfoliosExternalAccountsQueryParameters): QueryKey;
export function externalAccountsGetPortfoliosQueryKey(provider: string, accountIdentifier?: string | undefined): QueryKey;
export function externalAccountsGetPortfoliosQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { provider, accountIdentifier,  } = params[0] as ExternalAccountsGetPortfoliosExternalAccountsQueryParameters;

    return trimArrayEnd([
        'ExternalAccountsClient',
        'externalAccountsGetPortfolios',
        provider as any,
        accountIdentifier as any,
      ]);
  } else {
    return trimArrayEnd([
        'ExternalAccountsClient',
        'externalAccountsGetPortfolios',
        ...params
      ]);
  }
}
export function __externalAccountsGetPortfolios(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.externalAccountsGetPortfolios(
      context.queryKey[2] as string,       context.queryKey[3] as string | undefined,axiosConfig    );
}

export function useExternalAccountsGetPortfoliosQuery<TSelectData = Types.ListResultDtoOfExternalPortfolioDto, TError = unknown>(dto: ExternalAccountsGetPortfoliosExternalAccountsQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfExternalPortfolioDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function useExternalAccountsGetPortfoliosQuery<TSelectData = Types.ListResultDtoOfExternalPortfolioDto, TError = unknown>(provider: string, accountIdentifier?: string | undefined, options?: Omit<UseQueryOptions<Types.ListResultDtoOfExternalPortfolioDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useExternalAccountsGetPortfoliosQuery<TSelectData = Types.ListResultDtoOfExternalPortfolioDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfExternalPortfolioDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let provider: any = undefined;
  let accountIdentifier: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ provider, accountIdentifier,  } = params[0] as ExternalAccountsGetPortfoliosExternalAccountsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [provider, accountIdentifier, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfExternalPortfolioDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __externalAccountsGetPortfolios(context, axiosConfig) : __externalAccountsGetPortfolios,
    queryKey: externalAccountsGetPortfoliosQueryKey(provider, accountIdentifier),
    ...externalAccountsGetPortfoliosDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfExternalPortfolioDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function setExternalAccountsGetPortfoliosData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfExternalPortfolioDto | undefined) => Types.ListResultDtoOfExternalPortfolioDto, provider: string, accountIdentifier?: string | undefined) {
  queryClient.setQueryData(externalAccountsGetPortfoliosQueryKey(provider, accountIdentifier),
    updater
  );
}

/**
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function setExternalAccountsGetPortfoliosDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfExternalPortfolioDto | undefined) => Types.ListResultDtoOfExternalPortfolioDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function externalAccountsAuthenticateInitUrl(provider: string): string {
  let url_ = getBaseUrl() + "/api/external/accounts/{provider}/authenticate-init";
if (provider === undefined || provider === null)
  throw new Error("The parameter 'provider' must be defined.");
url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function externalAccountsAuthenticateInitMutationKey(provider: string): MutationKey {
  return trimArrayEnd([
      'ExternalAccountsClient',
      'externalAccountsAuthenticateInit',
      provider as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useExternalAccountsAuthenticateInitMutation<TContext>(provider: string, options?: Omit<UseMutationOptions<Types.ProviderAuthenticateDto, unknown, Types.ProviderAuthenticateInput, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ProviderAuthenticateDto, unknown, Types.ProviderAuthenticateInput, TContext> {
  const key = externalAccountsAuthenticateInitMutationKey(provider);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ProviderAuthenticateInput) => Client.externalAccountsAuthenticateInit(provider, body),
    mutationKey: key,
  });
}
  
type ExternalAccountsAuthenticateInit__MutationParameters = ExternalAccountsAuthenticateInitExternalAccountsQueryParameters & {
  body: Types.ProviderAuthenticateInput;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useExternalAccountsAuthenticateInitMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.ProviderAuthenticateDto, unknown, ExternalAccountsAuthenticateInit__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ExternalAccountsAuthenticateInitExternalAccountsQueryParameters}): UseMutationResult<Types.ProviderAuthenticateDto, unknown, ExternalAccountsAuthenticateInit__MutationParameters, TContext> {
  const key = externalAccountsAuthenticateInitMutationKey(options?.parameters?.provider!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ExternalAccountsAuthenticateInit__MutationParameters) => Client.externalAccountsAuthenticateInit(data.provider ?? options?.parameters?.provider!, data.body),
  mutationKey: key,
});
}
  
export function externalAccountsAuthenticateCollectUrl(provider: string): string {
  let url_ = getBaseUrl() + "/api/external/accounts/{provider}/authenticate-collect";
if (provider === undefined || provider === null)
  throw new Error("The parameter 'provider' must be defined.");
url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function externalAccountsAuthenticateCollectMutationKey(provider: string): MutationKey {
  return trimArrayEnd([
      'ExternalAccountsClient',
      'externalAccountsAuthenticateCollect',
      provider as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useExternalAccountsAuthenticateCollectMutation<TContext>(provider: string, options?: Omit<UseMutationOptions<Types.ProviderAuthenticateCollectDto, unknown, Types.ExternalAccountAuthenticateCollectDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ProviderAuthenticateCollectDto, unknown, Types.ExternalAccountAuthenticateCollectDto, TContext> {
  const key = externalAccountsAuthenticateCollectMutationKey(provider);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ExternalAccountAuthenticateCollectDto) => Client.externalAccountsAuthenticateCollect(provider, body),
    mutationKey: key,
  });
}
  
type ExternalAccountsAuthenticateCollect__MutationParameters = ExternalAccountsAuthenticateCollectExternalAccountsQueryParameters & {
  body: Types.ExternalAccountAuthenticateCollectDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useExternalAccountsAuthenticateCollectMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.ProviderAuthenticateCollectDto, unknown, ExternalAccountsAuthenticateCollect__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ExternalAccountsAuthenticateCollectExternalAccountsQueryParameters}): UseMutationResult<Types.ProviderAuthenticateCollectDto, unknown, ExternalAccountsAuthenticateCollect__MutationParameters, TContext> {
  const key = externalAccountsAuthenticateCollectMutationKey(options?.parameters?.provider!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ExternalAccountsAuthenticateCollect__MutationParameters) => Client.externalAccountsAuthenticateCollect(data.provider ?? options?.parameters?.provider!, data.body),
  mutationKey: key,
});
}
  
export function externalAccountsImportExternalPortfoliosUrl(): string {
  let url_ = getBaseUrl() + "/api/external/accounts/import";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function externalAccountsImportExternalPortfoliosMutationKey(): MutationKey {
  return trimArrayEnd([
      'ExternalAccountsClient',
      'externalAccountsImportExternalPortfolios',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useExternalAccountsImportExternalPortfoliosMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.PortfolioImportInput, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PortfolioImportInput, TContext> {
  const key = externalAccountsImportExternalPortfoliosMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.PortfolioImportInput) => Client.externalAccountsImportExternalPortfolios(body),
    mutationKey: key,
  });
}
  
export function externalAccountsSyncExternalPortfoliosBankIdUrl(provider: string): string {
  let url_ = getBaseUrl() + "/api/external/accounts/{provider}/sync";
if (provider === undefined || provider === null)
  throw new Error("The parameter 'provider' must be defined.");
url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function externalAccountsSyncExternalPortfoliosBankIdMutationKey(provider: string): MutationKey {
  return trimArrayEnd([
      'ExternalAccountsClient',
      'externalAccountsSyncExternalPortfoliosBankId',
      provider as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useExternalAccountsSyncExternalPortfoliosBankIdMutation<TContext>(provider: string, options?: Omit<UseMutationOptions<void, unknown, Types.SyncProviderInput, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SyncProviderInput, TContext> {
  const key = externalAccountsSyncExternalPortfoliosBankIdMutationKey(provider);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SyncProviderInput) => Client.externalAccountsSyncExternalPortfoliosBankId(provider, body),
    mutationKey: key,
  });
}
  
type ExternalAccountsSyncExternalPortfoliosBankId__MutationParameters = ExternalAccountsSyncExternalPortfoliosBankIdExternalAccountsQueryParameters & {
  body: Types.SyncProviderInput;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useExternalAccountsSyncExternalPortfoliosBankIdMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ExternalAccountsSyncExternalPortfoliosBankId__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ExternalAccountsSyncExternalPortfoliosBankIdExternalAccountsQueryParameters}): UseMutationResult<void, unknown, ExternalAccountsSyncExternalPortfoliosBankId__MutationParameters, TContext> {
  const key = externalAccountsSyncExternalPortfoliosBankIdMutationKey(options?.parameters?.provider!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ExternalAccountsSyncExternalPortfoliosBankId__MutationParameters) => Client.externalAccountsSyncExternalPortfoliosBankId(data.provider ?? options?.parameters?.provider!, data.body),
  mutationKey: key,
});
}